var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_891_301)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 28C27.82 28 30.48 25.32 30.48 22L30.5 10C30.5 6.68 27.82 4 24.5 4C21.18 4 18.5 6.68 18.5 10V22C18.5 25.32 21.18 28 24.5 28ZM35.1 22C35.1 28 30.02 32.2 24.5 32.2C18.98 32.2 13.9 28 13.9 22H10.5C10.5 28.82 15.94 34.46 22.5 35.44V42H26.5V35.44C33.06 34.48 38.5 28.84 38.5 22H35.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_891_301"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMic);
export default __webpack_public_path__ + "static/media/icon-mic.f71d779114aea6e7fca61e0e3797c1bf.svg";
export { ForwardRef as ReactComponent };